import React, { useEffect } from 'react';
import { ChevronRight } from 'lucide-react';
import AOS from "aos";
import "aos/dist/aos.css";

const Banner = () => {
  useEffect(() => {
    AOS.init({ duration: 1200, once: true });
  }, []);

  return (
    <div className="relative bg-gray-900 overflow-hidden">
      {/* Background Image */}
      <div
        className="absolute about_bg_image inset-0 bg-cover bg-center bg-no-repeat"

      >
        <div className="absolute inset-0 bg-gray-900 bg-opacity-75"></div>
      </div>

      {/* Geometric Shapes */}
      <div className="absolute inset-0 overflow-hidden">
        {/* Blue Angular Shape */}
        <div
          className="absolute top-0 right-0 w-1/2 lg:w-1/3 h-full"
          data-aos="fade-left"
        >
          <div className="relative h-full">
            {/* First gradient - fully transparent */}
            <div className="absolute inset-0 bg-gradient-to-br from-blue-600/0 to-blue-800/100 transform skew-x-12 origin-top-right scale-110"></div>

            {/* Second gradient - fully transparent */}
            <div className="absolute inset-0 bg-gradient-to-br from-blue-500/0 to-blue-700/100 transform skew-x-6 origin-top-right scale-105"></div>
          </div>
        </div>


        {/* Abstract Line Patterns */}
        <div className="absolute top-1/4 right-10 lg:right-20" data-aos="fade-left" data-aos-delay="300">
          <div className="space-y-2">
            {[...Array(8)].map((_, i) => (
              <div
                key={i}
                className="h-0.5 bg-white opacity-10"
                style={{ width: `${60 - i * 5}px` }}
              ></div>
            ))}
          </div>
        </div>

        {/* Circular Elements */}
        <div className="absolute top-20 left-20 w-32 h-32 border border-blue-500/30 rounded-full" data-aos="zoom-in"></div>
        <div className="absolute bottom-20 left-1/4 w-16 h-16 border border-white/20 rounded-full" data-aos="zoom-in" data-aos-delay="200"></div>
        <div className="absolute top-1/2 right-1/4 w-24 h-24 border border-blue-400/20 rounded-full" data-aos="zoom-in" data-aos-delay="400"></div>

        {/* Dots Pattern */}
        <div className="absolute bottom-32 right-32 grid grid-cols-4 gap-2 opacity-30" data-aos="fade-up" data-aos-delay="600">
          {[...Array(16)].map((_, i) => (
            <div key={i} className="w-1 h-1 bg-white rounded-full"></div>
          ))}
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10 containers mx-auto px-4 flex items-center min-h-[60vh] lg:min-h-[70vh]">
        <div className="w-full lg:w-1/2" data-aos="fade-right">

    

          {/* Main Heading */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-white leading-tight mb-8">
            About Us
          </h1>

          {/* Subtitle */}
          <p className="text-gray-300 text-lg lg:text-xl leading-relaxed max-w-2xl mb-8">
            At Dynamic Softlink, we deliver cutting-edge IT solutions and digital services that empower businesses to thrive in today’s fast-paced world. From custom software development to AI-driven automation, our focus is simple: turning your ideas into impactful digital experiences
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <button className="button_same  py-[14px] px-[18px] text-white  rounded-xl font-semibold text-lg transition-all duration-200 shadow-lg hover:shadow-xl hover:scale-105">
              Learn More About Us
            </button>
            <button className="border border-gray-500 text-white py-[14px] px-[18px] rounded-xl font-semibold text-lg hover:bg-white hover:text-gray-900 transition-all duration-200">
              Our Services
            </button>
          </div>
        </div>
      </div>

      {/* Animated Elements */}
      <div className="absolute top-10 left-10 w-3 h-3 bg-blue-500 rounded-full animate-pulse opacity-70"></div>
      <div className="absolute bottom-16 left-16 w-2 h-2 bg-white rounded-full animate-pulse opacity-40"></div>
      <div className="absolute top-1/3 left-1/3 w-1 h-1 bg-blue-400 rounded-full animate-ping opacity-70"></div>
    </div>
  );
};

export default Banner;
